import { render, staticRenderFns } from "./AppdownloadWap.vue?vue&type=template&id=1a93fe1e&scoped=true"
import script from "./AppdownloadWap.vue?vue&type=script&lang=js"
export * from "./AppdownloadWap.vue?vue&type=script&lang=js"
import style0 from "./AppdownloadWap.vue?vue&type=style&index=0&id=1a93fe1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a93fe1e",
  null
  
)

export default component.exports